import React, {useState} from 'react';
import { Box, Tab } from "@mui/material";
import Logout from "../components/Logout";
import { SocialMediaConvert } from '../components/MarketingCharts';
import NotiApp from '../components/tools/Noti/NotiApp'
import { TabPanel, TabContext, TabList } from '@mui/lab';

const ZonesContents = ['Charts', 'Tools']

const MarketingZone = () => {
  const [value, setValue] = useState("0");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Logout />
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={value} centered>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', display: "flex", justifyContent: "center" }}>
            <TabList onChange={handleChange}  aria-label="marketing tabs">
              {ZonesContents.map((item, idx) => (
                <Tab label = {item} value = {idx.toString()}></Tab>
              ))}
            </TabList>
          </Box>
          <TabPanel value = "0"><SocialMediaConvert /></TabPanel>
          <TabPanel value = "1"><NotiApp /></TabPanel>
        </TabContext>
      </Box>
    </>

  );
};

export default MarketingZone;